<h1 mat-dialog-title>{{title | translate}}</h1>

<div mat-dialog-content>
  <p>{{message | translate}}</p>
</div>

<div mat-dialog-actions
  class="justify-content-end">
  <button mat-button
  (click)="onDismiss()">{{cancelLocalizationKey | translate}}</button>
  @if (!isOkMode) {
    <button mat-raised-button
      color="primary"
    (click)="onConfirm()">{{confirmLocalizationKey | translate}}</button>
  }
</div>